import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const InputField = React.forwardRef<HTMLInputElement, any>((props, ref) => {
  const { infoText, ...restProps } = props;
  const getInfoText = () => {
    if (typeof infoText === "string") return infoText;
    if (infoText === true) {
      if (props.type === "number") {
        return "Field Type: Number, Accepted Values: Numeric only";
      }
      if (props.type === "text") {
        return "Field Type: Text, Accepted Values: Alphanumeric";
      }
    }
    return "";
  };

  const finalInfoText = getInfoText();

  return (
    <>
      <div className="form-floating position-relative">
        <input
          ref={ref}
          className="form-control"
          placeholder={props.placeholder || "name@example.com"}
          {...restProps}
        />
        <label htmlFor={props.id || "floatingInput"}>
          {props?.placeholder}
          {finalInfoText && !props.disabled && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${props.name}`}>{finalInfoText}</Tooltip>}
            >
              <a className="ms-1 align-self-center">
                <img className=" pe-auto" 
                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
              </a>
            </OverlayTrigger>
          )}
        </label>
      </div>
    </>
  );
});

export default InputField;
